import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useMilestone } from '../../contexts/MilestoneContext';
import { MilestoneStep } from '../../models/milestone.model';
import './BookingMilestone.css';
import Progress from "../B2B/Progress";
interface BookingMilestoneProps {
  currentStep?: number; 
}

const BookingMilestone: React.FC<BookingMilestoneProps> = ({ currentStep: propCurrentStep }) => {
  const userRole = useSelector((state: any) => state.auth.userRole) ?? '';
  const { currentStep: contextCurrentStep } = useMilestone();

  // Local state
  const [apiSteps, setApiSteps] = useState<MilestoneStep[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  if (userRole !== 'B2BUser') {
    return null;
  }
  if (loading) {
    return <div>Loading milestones...</div>;
  }

  // Use context or prop step number
  const currentStep = propCurrentStep ?? contextCurrentStep ?? 1;

  // If API provides steps dynamically
  const steps: MilestoneStep[] =
    apiSteps.length > 0
      ? apiSteps.map((step, index) => ({
          ...step,
          isCompleted: currentStep > index + 1,
          isActive: currentStep === index + 1,
        }))
      : [
          { step: 1, label: 'Properties Allocated', tooltip: 'Properties Allocated', isCompleted: currentStep > 1, isActive: currentStep === 1 },
          { step: 2, label: 'Shortlisted', tooltip: 'Shortlisted', isCompleted: currentStep > 2, isActive: currentStep === 2 },
          { step: 3, label: 'Request Reservation', tooltip: 'Request Reservation', isCompleted: currentStep > 3, isActive: currentStep === 3 },
          { step: 4, label: 'Booking In Progress', tooltip: 'Booking In Progress', isCompleted: currentStep >= 4, isActive: currentStep === 4 },
          { step: 5, label: 'Booking Completed', tooltip: 'Booking Completed', isCompleted: currentStep >= 5, isActive: currentStep === 5 },
        ];

  return (
    <div className="booking-milestone-container">
      <div className="milestone-progress-bar">
        {steps.map((step, index) => (
          <React.Fragment key={step.step || index}>
            <div
              className={`milestone-step ${step.isCompleted ? 'completed' : ''} ${step.isActive ? 'active' : ''}`}
              title={step.tooltip}
            >
              <div className="milestone-circle" title={step.tooltip}></div>
              <span className="milestone-label" title={step.tooltip}>
                {step.label}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div className={`milestone-connector ${currentStep > step.step ? 'completed' : ''}`}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default BookingMilestone;